import { mainStore } from '../stores/MainStore';

export const useAppStore = () => {
  return mainStore.appStore;
};

